import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../store';
import warn from '../../icons/warn';
import {selectHasCustomColor, selectIsSatisfied, selectSpcConfiguration} from '../selectors';
import {getValueOfFeature} from '../util/values';

@customElement('total-price')
export class TotalPrice extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				font-family: var(--font-family-light);
				color: var(--color-grey2);
				display: flex;
				flex-direction: column;
				justify-content: center;
			}

			.price {
				margin-right: var(--small-padding);;
				display: flex;
			}

			.icon {
				width: 11px;
				height: 11px;
				display: inline-block;
				stroke: var(--color-warn);
				fill: var(--color-warn)
			}

			.hoverinfo {
				transition: left 0.25s ease-out, opacity 0.25s ease-out;
				transform: translateX(-15%);
				display: block;
				opacity: 0;
				pointer-events: none;
				position: absolute;
				top: 50px;
				z-index: 10;
				margin: 0 auto;
				width: 200px;
			}

			:host(:hover) .hoverinfo {
				display: block;
				opacity: 1;
				transition-delay: 0.2s;
			}

			.hoverinfo .content {
				position: relative;
				border: var(--border-widget);
				padding: 0.5em 1em;
				background-color: var(--color-black);
				font-family: var(--font-family-light);
				color: var(--color-text-widget-value);
				font-size: var(--font-size-widget);
			}
        `
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.dashboardActive = state.status.dashboardActive;
		this.specsheetActive = state.status.specsheetActive;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.price = state.price.data;
		this.isSatisfied = selectIsSatisfied(state);
		this.spcConfiguration = selectSpcConfiguration(state);
	}

	isPriceVisible() {
		const region = getValueOfFeature('shared::Context::CX_Region', this.spcConfiguration);
		return region === 'Germany' && this.isSatisfied && this.state.status.family === 'Line';
	}
	isPriceFinal() {
		return selectHasCustomColor(this.state);
	}

	render() {
		return html`
			${when(this.isPriceVisible(),
					() => html`
						<span class="price">
							${msg('Price')}:
							${this.isSatisfied ? this.price.totalPriceInEuro : '--'} €
						</span>
						${when(this.isPriceFinal(),
							() => html`
								<span class="icon">${warn}</span>
								<div class="hoverinfo">
									<div class="content">
										<trans-label slot="title" key="TE_PriceIsNotFinal" context="D"></trans-label>
									</div>
								</div>
						`)}
					`)
			}
		`;
	}
}
